(function () {
  'use strict';

  const wraps = document.querySelectorAll('.bsb-st__wrap');
  if (!wraps.length) return;

  const updateFocus = (wrap) => {
    if (wrap.scrollWidth > wrap.clientWidth) {
      wrap.setAttribute('tabindex', '0');
    } else {
      wrap.removeAttribute('tabindex');
    }
  };

  wraps.forEach(updateFocus);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => updateFocus(entry.target));
    });
    wraps.forEach((wrap) => observer.observe(wrap));
  }
})();
